import React from "react";

export const COACH_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_instant-guidance-1/artifacts/69449ecd5a98f9c2_FB_IMG_1792584084246.jpg";

export const CoachAvatar = ({ size = "lg", speaking = false, className = "" }) => {
  const sizes = {
    sm: "w-14 h-14",
    md: "w-24 h-24",
    lg: "w-40 h-40 md:w-56 md:h-56",
    xl: "w-56 h-56 md:w-72 md:h-72",
  };
  return (
    <div
      data-testid="coach-avatar"
      className={`relative rounded-full overflow-hidden ${sizes[size]} ${className}`}
    >
      <div
        className={`absolute inset-0 rounded-full z-10 pointer-events-none ${speaking ? "coach-speaking" : ""}`}
        style={{ boxShadow: "0 0 0 3px rgba(42,59,50,0.08)" }}
      />
      <img
        src={COACH_IMG}
        alt="India Sadie, certified life coach"
        className="absolute inset-0 w-full h-full object-cover object-[50%_30%]"
        draggable={false}
      />
    </div>
  );
};

export default CoachAvatar;
